import React from 'react';
import './rush.css';
import './customers.css';
import { RushNav, RushFooter, useRushReveal } from './RushChrome';
import WaitlistForm from './WaitlistForm';

const Hero = () => (
  <section className="cust-hero">
    <div className="hero-mesh"></div>
    <div className="rs-container hero-anim" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <span className="hero-eyebrow"><span className="dot"></span>Early access · launching 2027</span>
      <h1 className="cust-h1">Be one of the first teams<br />on Rush Studio.</h1>
      <p className="cust-lead">We're not live yet — we're building Rush Studio in the open, alongside a small group of localization teams tired of the same broken workflow. Join early access and help shape the product before launch.</p>
    </div>
  </section>
);

const BENEFITS = [
  { title: 'A direct line to the founder', desc: 'No support queue. You talk to Chris — the person building it — and what you say lands in the roadmap.', icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M3 5h16v10H7l-4 3z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" /></svg> },
  { title: 'Shape what gets built', desc: 'Early feedback decides what ships next. The features you need are the ones we prioritise first.', icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 2.5l2.4 5 5.4.5-4.1 3.6 1.2 5.3L11 19.4 6.1 16.9l1.2-5.3L3.2 8l5.4-.5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /></svg> },
  { title: 'Founding-customer pricing', desc: 'Lock in early pricing that stays with you after launch — a thank-you for betting on us early.', icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.6" /><path d="M11 5.5v11M8.5 8h4a1.8 1.8 0 010 3.6h-3a1.8 1.8 0 000 3.6h4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg> },
];

const Benefits = () => (
  <section className="section">
    <div className="rs-container">
      <div className="section-head reveal">
        <div className="eyebrow">Early access</div>
        <h2>What you get for joining early.</h2>
        <p className="section-lead">Rush Studio is pre-launch — which is the best time to get in. Your problems shape what we build.</p>
      </div>
      <div className="reveal stagger" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
        {BENEFITS.map((b) => (
          <article key={b.title} style={{ background: 'var(--bg-card)', border: '1px solid var(--line)', borderRadius: 16, padding: '30px 26px' }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, display: 'grid', placeItems: 'center', background: 'var(--accent-soft)', color: 'var(--accent)', marginBottom: 18 }}>{b.icon}</div>
            <h3 style={{ fontSize: 19, margin: '0 0 8px', letterSpacing: '-0.01em' }}>{b.title}</h3>
            <p style={{ margin: 0, color: 'var(--ink-3)', fontSize: 15, lineHeight: 1.55 }}>{b.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const FORWHO = [
  "You've moved off translation agencies because they were too expensive — but machine translation alone left gaps.",
  "You work with IDML, DOCX and other real files, and you're tired of formatting breaking on every round-trip.",
  'You want a transparent workflow you can actually see into — not another black box to fight.',
];

const ForWho = () => (
  <section className="section" style={{ background: 'var(--bg-soft)', borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)' }}>
    <div className="rs-container">
      <div className="section-head reveal" style={{ textAlign: 'left', margin: '0 0 36px', maxWidth: 'none' }}>
        <div className="eyebrow">Who it's for</div>
        <h2 style={{ fontSize: 36 }}>Built for teams who hit the wall we hit.</h2>
      </div>
      <div className="reveal stagger" style={{ display: 'grid', gap: 14, maxWidth: 760 }}>
        {FORWHO.map((t, i) => (
          <div key={i} style={{ display: 'flex', gap: 16, alignItems: 'flex-start', padding: '20px 22px', background: 'var(--bg-card)', border: '1px solid var(--line)', borderRadius: 14 }}>
            <span style={{ flexShrink: 0, width: 26, height: 26, borderRadius: 999, background: 'var(--accent)', color: '#fff', display: 'grid', placeItems: 'center', fontSize: 13, fontWeight: 700 }}>{i + 1}</span>
            <p style={{ margin: 0, fontSize: 16, lineHeight: 1.5, color: 'var(--ink)' }}>{t}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const NextCTA = () => (
  <section className="section">
    <div className="rs-container">
      <div className="final-cta reveal reveal-scale">
        <h2>Want in early?</h2>
        <p>Join the early-access list. We'll be in touch as we open up spots — and we'll help you bring your projects, memory, and glossaries across.</p>
        <WaitlistForm source="customers-final" />
      </div>
    </div>
  </section>
);

const RushCustomersPage = () => {
  useRushReveal();
  return (
    <div className="rs">
      <RushNav active="customers" />
      <Hero />
      <Benefits />
      <ForWho />
      <NextCTA />
      <RushFooter />
    </div>
  );
};

export default RushCustomersPage;
